import Vue from 'vue';
import VueRouter from 'vue-router';
import util from 'libs/util';

Vue.use(VueRouter);

const AdminActivation = () =>
    import(
        /* webpackChunkName: "admin-activation" */

        './pages/admin-activation/AdminActivation.vue'
    );
const RequestResetPassword = () =>
    import(
        /* webpackChunkName: "request-reset-password" */

        './pages/reset-password/RequestResetPassword.vue'
    );
const ResetPassword = () =>
    import(
        /* webpackChunkName: "reset-password" */

        './pages/reset-password/ResetPassword.vue'
    );
const Login = () =>
    import(
        /* webpackChunkName: "login" */

        './pages/login/Login.vue'
    );
const Dashboard = () =>
    import(
        /* webpackChunkName: "dashboard" */

        './pages/dashboard/Dashboard.vue'
    );
const Statistic = () =>
    import(
        /* webpackChunkName: "statistic" */

        './pages/statistic/Statistic.vue'
    );
const AdminManage = () =>
    import(
        /* webpackChunkName: "admin-manage" */

        './pages/admins/AdminManage.vue'
    );
const AdminPermission = () =>
    import(
        /* webpackChunkName: "admin-activation" */

        './pages/admins/permission'
    );
const AdminRoleList = () =>
    import(
        /* webpackChunkName: "admin-role-list" */

        './pages/admins/roles'
    );
const ActivityLog = () =>
    import(
        /* webpackChunkName: "activity-log" */

        './pages/admins/activity-log'
    );
const AdminList = () =>
    import(
        /* webpackChunkName: "admin-list" */

        './pages/admins/AdminList.vue'
    );
const AdminInvite = () =>
    import(
        /* webpackChunkName: "admin-invite" */

        './pages/admins/AdminInvite.vue'
    );
const AdminUpdate = () =>
    import(
        /* webpackChunkName: "admin-update" */

        './pages/admins/AdminUpdate.vue'
    );
const AdminChangePassword = () =>
    import(
        /* webpackChunkName: "admin-change-password" */

        './pages/admins/AdminChangePassword.vue'
    );
const AdminChangeRole = () =>
    import(
        /* webpackChunkName: "admin-change-role" */

        './pages/admins/AdminChangeRole.vue'
    );
const MemberManage = () =>
    import(
        /* webpackChunkName: "member-manage" */

        './pages/members/MemberManage.vue'
    );
const MemberList = () =>
    import(
        /* webpackChunkName: "member-list" */

        './pages/members/list'
    );
const MemberReport = () =>
    import(
        /* webpackChunkName: "member-report" */

        './pages/members/report'
    );
const MemberAdvicement = () =>
    import(
        /* webpackChunkName: "member-advicement" */

        './pages/members/advicement'
    );
const MemberUpdate = () =>
    import(
        /* webpackChunkName: "member-update" */

        './pages/members/update'
    );
const MutateWallet = () =>
    import(
        /* webpackChunkName: "mutate-wallet" */

        './pages/members/mutate-wallet'
    );
const MutateMembershipChance = () =>
    import(
        /* webpackChunkName: "mutate-membership-chance" */

        './pages/members/mutate-membership-chance'
    );
const MemberChangePassword = () =>
    import(
        /* webpackChunkName: "member-change-password" */

        './pages/members/change-password'
    );
const MembershipRuleManage = () =>
    import(
        /* webpackChunkName: "membership-rule-manage" */

        './pages/membership-rules/MembershipRuleManage.vue'
    );
const MembershipRuleList = () =>
    import(
        /* webpackChunkName: "membership-rule-list" */

        './pages/membership-rules/list'
    );
const ProfessionalManage = () =>
    import(
        /* webpackChunkName: "professional-manage" */

        './pages/professional/ProfessionalManage.vue'
    );
const ProfessionalList = () =>
    import(
        /* webpackChunkName: "professional-list" */

        './pages/professional/list'
    );
const ProfessionalServiceList = () =>
    import(
        /* webpackChunkName: "professional-service-list" */

        './pages/professional/professional-service'
    );
const ProfessionServiceUpdate = () =>
    import(
        /* webpackChunkName: "professional-service-update" */

        './pages/professional/professional-service-update'
    );
const ProfessionDetailUpdate = () =>
    import(
        /* webpackChunkName: "professional-update" */

        './pages/professional/update'
    );
const ClientComplain = () =>
    import(
        /* webpackChunkName: "client-complain" */

        './pages/professional/client-complain'
    );
const ComplainDetail = () =>
    import(
        /* webpackChunkName: "complain-detail" */

        './pages/professional/complain-detail'
    );
const ProfessionList = () =>
    import(
        /* webpackChunkName: "professional-profession" */

        './pages/professional/profession'
    );
const ProfessionCreate = () =>
    import(
        /* webpackChunkName: "professional-profession-create" */

        './pages/professional/profession-create'
    );
const ProfessionUpdate = () =>
    import(
        /* webpackChunkName: "professional-profession-update" */

        './pages/professional/profession-update'
    );
const SkillList = () =>
    import(
        /* webpackChunkName: "professional-skill" */

        './pages/professional/skill'
    );
const SkillCreate = () =>
    import(
        /* webpackChunkName: "professional-skill-create" */

        './pages/professional/skill-create'
    );
const SkillUpdate = () =>
    import(
        /* webpackChunkName: "professional-skill-update" */

        './pages/professional/skill-update'
    );
const VerificationRequest = () =>
    import(
        /* webpackChunkName: "professional-verification-request" */

        './pages/professional/verification-request'
    );
const VerificationDetail = () =>
    import(
        /* webpackChunkName: "professional-verification-detail" */

        './pages/professional/verification-detail'
    );
const SurveiRequest = () =>
    import(
        /* webpackChunkName: "professional-survei-request" */

        './pages/professional/survei-request'
    );
const SurveiRequestDetail = () =>
    import(
        /* webpackChunkName: "professional-survei-request-detail" */

        './pages/professional/survei-request-detail'
    );
const DirectOrderList = () =>
    import(
        /* webpackChunkName: "professional-direct-order-list" */

        './pages/professional/direct-order'
    );
const DirectOrderComplainDetail = () =>
    import(
        /* webpackChunkName: "direct-order-complain-detailt" */

        './pages/professional/direct-order-complain-detail'
    );
const DirectOrderTrackProgress = () =>
    import(
        /* webpackChunkName: "professional-direct-order-track-progress" */
        './pages/professional/direct-order-track-progress'
    );
const NoPermit = () =>
    import(
        /* webpackChunkName: "no-permit" */

        './pages/no-permit/NoPermit.vue'
    );
const MembershipManage = () =>
    import(
        /* webpackChunkName: "membership-manage" */

        './pages/memberships/MembershipManage.vue'
    );
const MembershipList = () =>
    import(
        /* webpackChunkName: "membership-list" */

        './pages/memberships/MembershipList.vue'
    );
const MembershipUpdate = () =>
    import(
        /* webpackChunkName: "membership-update" */

        './pages/memberships/MembershipUpdate.vue'
    );
const MembershipCreate = () =>
    import(
        /* webpackChunkName: "membership-create" */

        './pages/memberships/MembershipCreate.vue'
    );
const OrderManage = () =>
    import(
        /* webpackChunkName: "order-manage" */

        './pages/orders/OrderManage.vue'
    );
const MembershipOrderList = () =>
    import(
        /* webpackChunkName: "membership-order-list" */

        './pages/orders/MembershipOrderList.vue'
    );
const TopupOrderList = () =>
    import(
        /* webpackChunkName: "topup-order-list" */

        './pages/orders/TopupOrderList.vue'
    );
const WalletHistories = () =>
    import(
        /* webpackChunkName: "wallet-histories" */

        './pages/wallets/wallet-histories'
    );
const PayoutManage = () =>
    import(
        /* webpackChunkName: "payout-manage" */

        './pages/payout/PayoutManage.vue'
    );
const PayoutList = () =>
    import(
        /* webpackChunkName: "payout-list" */

        './pages/payout/list'
    );
const SettingManage = () =>
    import(
        /* webpackChunkName: "setting-manage" */

        './pages/settings/SettingManage.vue'
    );
const ConsumeSettingUpdate = () =>
    import(
        /* webpackChunkName: "consume-setting-update" */

        './pages/settings/ConsumeSettingUpdate.vue'
    );
const InternalSettingUpdate = () =>
    import(
        /* webpackChunkName: "internal-setting-update" */

        './pages/settings/InternalSettingUpdate.vue'
    );
const AdvertisementManage = () =>
    import(
        /* webpackChunkName: "advertisement-manage" */

        './pages/advertisements/AdvertisementManage.vue'
    );
const PropertyAdsList = () =>
    import(
        /* webpackChunkName: "property-ads-list" */

        './pages/advertisements/property/list'
    );
const PropertyAdsCreate = () =>
    import(
        /* webpackChunkName: "property-ads-create" */

        './pages/advertisements/property/create'
    );
const PropertyAdsUpdate = () =>
    import(
        /* webpackChunkName: "property-ads-update" */

        './pages/advertisements/property/update'
    );
const ProjectAdsList = () =>
    import(
        /* webpackChunkName: "project-ads-list" */

        './pages/advertisements/project/list'
    );
const ProjectAdsCreate = () =>
    import(
        /* webpackChunkName: "project-ads-create" */

        './pages/advertisements/project/create'
    );
const ProjectAdsUpdate = () =>
    import(
        /* webpackChunkName: "project-ads-update" */

        './pages/advertisements/project/update'
    );
const CrowdfundManage = () =>
    import(
        /* webpackChunkName: "crowdfund-manage" */

        './pages/crowdfund/CrowdfundManage.vue'
    );
const CrowdfundPropose = () =>
    import(
        /* webpackChunkName: "crowdfund-propose" */

        './pages/crowdfund/propose'
    );
const CrowdfundList = () =>
    import(
        /* webpackChunkName: "crowdfund-list" */

        './pages/crowdfund/list'
    );
const CrowdfundUpdate = () =>
    import(
        /* webpackChunkName: "crowdfund-update" */

        './pages/crowdfund/update'
    );
const MarketplaceList = () =>
    import(
        /* webpackChunkName: "marketplace-list" */

        './pages/crowdfund/marketplace'
    );
const ConvertRequest = () =>
    import(
        /* webpackChunkName: "crowdfund-convert-request" */

        './pages/crowdfund/convert-request'
    );
const InvestorList = () =>
    import(
        /* webpackChunkName: "investor-list" */

        './pages/crowdfund/investors'
    );
const InvestmentHistoryList = () =>
    import(
        /* webpackChunkName: "investment-history-list" */

        './pages/crowdfund/investment-history'
    );
const InvestmentBroadcast = () =>
    import(
        /* webpackChunkName: "investment-broadcast" */

        './pages/crowdfund/broadcast'
    );
const BroadcastList = () =>
    import(
        /* webpackChunkName: "broadcast-list" */

        './pages/crowdfund/broadcasts'
    );
const ReferralManage = () =>
    import(
        /* webpackChunkName: "referral-manage" */

        './pages/referral/ReferralManage.vue'
    );
const MemberReferral = () =>
    import(
        /* webpackChunkName: "member-referral" */

        './pages/referral/member'
    );
const CMSManage = () =>
    import(
        /* webpackChunkName: "cms-manage" */

        './pages/cms/CMSManage.vue'
    );
const Compro = () =>
    import(
        /* webpackChunkName: "compro" */

        './pages/cms/compro'
    );
const HiwAgentReferral = () =>
    import(
        /* webpackChunkName: "hiw-agent-referral" */

        './pages/cms/hiw-agent-referral'
    );
const HiwCrowdinvest = () =>
    import(
        /* webpackChunkName: "hiw-crowdinvest" */

        './pages/cms/hiw-crowdinvest'
    );
const HiwProfessional = () =>
    import(
        /* webpackChunkName: "hiw-professional" */

        './pages/cms/hiw-professional'
    );
const OurTeamList = () =>
    import(
        /* webpackChunkName: "our-team-list" */

        './pages/cms/our-team/list'
    );
const OurTeamUpdate = () =>
    import(
        /* webpackChunkName: "our-team-update" */

        './pages/cms/our-team/update'
    );
const OurTeamCreate = () =>
    import(
        /* webpackChunkName: "our-team-create" */

        './pages/cms/our-team/create'
    );
const CompanyList = () =>
    import(
        /* webpackChunkName: "company-list" */

        './pages/cms/company/list'
    );
const CompanyUpdate = () =>
    import(
        /* webpackChunkName: "company-update" */

        './pages/cms/company/update'
    );
const CompanyCreate = () =>
    import(
        /* webpackChunkName: "company-create" */

        './pages/cms/company/create'
    );
const Faq = () =>
    import(
        /* webpackChunkName: "faq" */

        './pages/cms/faq'
    );
const RiskAndWarning = () =>
    import(
        /* webpackChunkName: "risk-and-warning" */

        './pages/cms/risk-and-warning'
    );
const Tnc = () =>
    import(
        /* webpackChunkName: "tnc" */

        './pages/cms/tnc'
    );
const CookiePolicy = () =>
    import(
        /* webpackChunkName: "cookie-policy" */

        './pages/cms/cookie-policy'
    );
const PrivacyPolicy = () =>
    import(
        /* webpackChunkName: "privacy-policy" */

        './pages/cms/privacy-policy'
    );
const BasicInfo = () =>
    import(
        /* webpackChunkName: "basic-info" */

        './pages/cms/basic-info'
    );
const HomePage = () =>
    import(
        /* webpackChunkName: "home-page" */

        './pages/cms/home-page'
    );
const MembershipDesc = () =>
    import(
        /* webpackChunkName: "membership-desc" */

        './pages/cms/membership-desc'
    );

const NotificationManage = () =>
    import(
        /* webpackChunkName: "notification-manage" */

        './pages/notification/NotificationManage.vue'
    );
const NotificationBroadcast = () =>
    import(
        /* webpackChunkName: "notification-broadcast" */

        './pages/notification/broadcast'
    );

const routes = [
    {
        name: 'admin-activation',
        path: '/admin-activation/:activationHash',
        component: AdminActivation
    },
    {
        name: 'request-reset-password',
        path: '/request-reset-password',
        component: RequestResetPassword
    },
    {
        name: 'reset-password',
        path: '/reset-password/:identityHash',
        component: ResetPassword
    },
    { name: 'login', path: '/login', component: Login },
    { name: 'dashboard', path: '/', component: Dashboard },
    { name: 'statistic', path: '/statistic', component: Statistic },
    {
        path: '/manage-admin',
        component: AdminManage,
        meta: {
            required: ['Admin:READ']
        },
        children: [
            {
                name: 'admin-list',
                path: 'list',
                component: AdminList,
                meta: {
                    required: 'Admin:READ'
                }
            },
            {
                name: 'admin-invite',
                path: 'invite',
                component: AdminInvite,
                meta: {
                    required: ['Admin:READ', 'Admin:CREATE']
                }
            },
            {
                name: 'admin-update',
                path: ':id/update',
                component: AdminUpdate,
                meta: {
                    required: ['Admin:READ', 'Admin:UPDATE']
                }
            },
            {
                name: 'admin-change-password',
                path: ':id/change-password',
                component: AdminChangePassword,
                meta: {
                    required: ['Admin:READ', 'Admin:UPDATE']
                }
            },
            {
                name: 'admin-change-role',
                path: ':id/change-role',
                component: AdminChangeRole,
                meta: {
                    required: ['Admin:READ', 'Admin:UPDATE']
                }
            },
            {
                name: 'admin-permission',
                path: 'permission',
                component: AdminPermission,
                meta: {
                    required: ['AdminPermission:READ', 'AdminPermission:UPDATE']
                }
            },
            {
                name: 'admin-roles',
                path: 'roles',
                component: AdminRoleList,
                meta: {
                    required: ['AdminRole:READ']
                }
            },
            {
                name: 'activity-log',
                path: 'activity-log',
                component: ActivityLog,
                meta: {
                    required: ['ActivityLog:READ']
                }
            },
            {
                path: '',
                component: AdminList,
                meta: {
                    required: ['Admin:READ']
                }
            }
        ]
    },
    {
        path: '/manage-membership',
        component: MembershipManage,
        meta: {
            required: ['Membership:READ']
        },
        children: [
            {
                name: 'membership-list',
                path: 'list',
                component: MembershipList,
                meta: {
                    required: 'Membership:READ'
                }
            },
            {
                name: 'membership-update',
                path: ':id/update',
                component: MembershipUpdate,
                meta: {
                    required: ['Membership:READ', 'Membership:UPDATE']
                }
            },
            {
                name: 'membership-create',
                path: 'create',
                component: MembershipCreate,
                meta: {
                    required: ['Membership:READ', 'Membership:CREATE']
                }
            },
            {
                path: '',
                component: MembershipList,
                meta: {
                    required: ['Membership:READ']
                }
            }
        ]
    },
    {
        path: '/manage-order',
        component: OrderManage,
        meta: {
            required: ['Order:READ']
        },
        children: [
            {
                name: 'membership-order-list',
                path: 'membership-order-list',
                component: MembershipOrderList,
                meta: {
                    required: ['Order:READ', 'Order:UPDATE']
                }
            },
            {
                name: 'topup-order-list',
                path: 'topup-order-list',
                component: TopupOrderList,
                meta: {
                    required: ['Order:READ', 'Order:UPDATE']
                }
            },
            {
                name: 'wallet-histories',
                path: 'wallet-histories',
                component: WalletHistories,
                meta: {
                    required: ['Order:READ']
                }
            }
        ]
    },
    {
        path: '/manage-advertisement',
        component: AdvertisementManage,
        meta: {
            required: ['Advertisement:READ']
        },
        children: [
            {
                name: 'property-advertisement-list',
                path: 'advertisement/property-list',
                component: PropertyAdsList,
                meta: {
                    required: ['Advertisement:READ', 'Advertisement:UPDATE']
                }
            },
            {
                name: 'property-advertisement-create',
                path: 'advertisement/property-create',
                component: PropertyAdsCreate,
                meta: {
                    required: ['Advertisement:CREATE', 'Property:CREATE']
                }
            },
            {
                name: 'property-advertisement-update',
                path: 'advertisement/:id/property/:propertyId/update',
                component: PropertyAdsUpdate,
                meta: {
                    required: [
                        'Advertisement:READ',
                        'Advertisement:UPDATE',
                        'Property:READ',
                        'Property:UPDATE'
                    ]
                }
            },
            {
                name: 'project-advertisement-list',
                path: 'advertisement/project-list',
                component: ProjectAdsList,
                meta: {
                    required: ['Advertisement:READ', 'Advertisement:UPDATE']
                }
            },
            {
                name: 'project-advertisement-create',
                path: 'advertisement/project-create',
                component: ProjectAdsCreate,
                meta: {
                    required: ['Advertisement:CREATE']
                }
            },
            {
                name: 'project-advertisement-update',
                path: 'advertisement/:id/project/:projectId/update',
                component: ProjectAdsUpdate,
                meta: {
                    required: [
                        'Advertisement:READ',
                        'Advertisement:UPDATE',
                        'Project:READ',
                        'Project:UPDATE'
                    ]
                }
            }
        ]
    },
    {
        path: '/manage-setting',
        component: SettingManage,
        meta: {
            required: []
        },
        children: [
            {
                name: 'internal-setting-update',
                path: 'internal-setting-update',
                component: InternalSettingUpdate,
                meta: {
                    required: ['InternalSetting:READ', 'InternalSetting:UPDATE']
                }
            },
            {
                name: 'consume-setting-update',
                path: 'consume-setting-update',
                component: ConsumeSettingUpdate,
                meta: {
                    required: ['ConsumeSetting:READ', 'ConsumeSetting:UPDATE']
                }
            }
        ]
    },
    {
        path: '/manage-member',
        component: MemberManage,
        children: [
            {
                name: 'member-list',
                path: 'list',
                component: MemberList,
                meta: {
                    required: ['Member:READ', 'Member:UPDATE']
                }
            },
            {
                name: 'member-report',
                path: 'member-report',
                component: MemberReport,
                meta: {
                    required: ['MemberReport:READ', 'MemberReport:UPDATE']
                }
            },
            {
                name: 'member-advicement',
                path: 'member-advicement',
                component: MemberAdvicement,
                meta: {
                    required: ['Advicement:READ', 'Advicement:UPDATE']
                }
            },
            {
                name: 'member-update',
                path: ':id/update',
                component: MemberUpdate,
                meta: {
                    required: ['Member:READ', 'Member:UPDATE']
                }
            },
            {
                name: 'mutate-wallet',
                path: ':id/mutate-wallet',
                component: MutateWallet,
                meta: {
                    required: [
                        'Member:READ',
                        'Member:UPDATE',
                        'Wallet:READ',
                        'Wallet:UPDATE'
                    ]
                }
            },
            {
                name: 'mutate-membership-chance',
                path: ':id/mutate-membership-chance',
                component: MutateMembershipChance,
                meta: {
                    required: [
                        'Member:READ',
                        'Member:UPDATE',
                        'MembershipUsage:READ',
                        'MembershipUsage:UPDATE'
                    ]
                }
            },
            {
                name: 'member-change-password',
                path: ':id/change-password',
                component: MemberChangePassword,
                meta: {
                    required: ['Member:READ', 'Member:UPDATE']
                }
            },
            { path: '', component: MemberList }
        ]
    },
    {
        path: '/manage-membership-rule',
        component: MembershipRuleManage,
        children: [
            {
                name: 'membership-rule-list',
                path: ':id/list',
                component: MembershipRuleList,
                meta: {
                    required: ['MembershipRule:READ', 'MembershipRule:UPDATE']
                }
            }
        ]
    },
    {
        path: '/manage-professional',
        component: ProfessionalManage,
        children: [
            {
                name: 'professional-list',
                path: 'list',
                component: ProfessionalList,
                meta: {
                    required: [
                        'ProfessionDetail:READ',
                        'ProfessionDetail:UPDATE'
                    ]
                }
            },
            {
                name: 'professional-service-list',
                path: 'professional-service-list',
                component: ProfessionalServiceList,
                meta: {
                    required: [
                        'ProfessionalService:READ',
                        'ProfessionalService:UPDATE'
                    ]
                }
            },
            {
                name: 'professional-service-update',
                path: 'professional-service/:id/update',
                component: ProfessionServiceUpdate,
                meta: {
                    required: [
                        'ProfessionalService:READ',
                        'ProfessionalService:UPDATE'
                    ]
                }
            },
            {
                name: 'direct-order-list',
                path: 'direct-order',
                component: DirectOrderList,
                meta: {
                    required: [
                        'ProfessionalOrderDetail:READ',
                        'ProfessionalOrderDetail:UPDATE'
                    ]
                }
            },
            {
                name: 'direct-order-complain-detail',
                path: 'direct-order-complain-detail/:id',
                component: DirectOrderComplainDetail,
                meta: {
                    required: [
                        'ProfessionalOrderDetail:READ',
                        'ProfessionalOrderDetail:UPDATE'
                    ]
                }
            },
            {
                name: 'direct-order-track-progress',
                path: 'direct-order-track-progress/:id',
                component: DirectOrderTrackProgress,
                meta: {
                    required: [
                        'ProfessionalOrderDetail:READ',
                        'ProfessionalOrderDetail:UPDATE'
                    ]
                }
            },
            {
                name: 'professional-update',
                path: ':id/update',
                component: ProfessionDetailUpdate,
                meta: {
                    required: [
                        'ProfessionDetail:READ',
                        'ProfessionDetail:UPDATE'
                    ]
                }
            },
            {
                name: 'client-complain',
                path: 'client-complain',
                component: ClientComplain,
                meta: {
                    required: [
                        'ProfessionalProposal:READ',
                        'ProfessionalProposal:UPDATE',
                        'WorkspaceDetail:READ',
                        'WorkspaceDetail:UPDATE'
                    ]
                }
            },
            {
                name: 'complain-detail',
                path: 'complain-detail/:id',
                component: ComplainDetail,
                meta: {
                    required: ['WorkspaceDetail:READ', 'WorkspaceDetail:UPDATE']
                }
            },
            {
                name: 'professional-verification-request',
                path: 'verification-request',
                component: VerificationRequest,
                meta: {
                    required: [
                        'ProfessionalVerificationRequest:READ',
                        'ProfessionalVerificationRequest:UPDATE'
                    ]
                }
            },
            {
                name: 'professional-verification-detail',
                path: 'verification-detail/:id',
                component: VerificationDetail,
                meta: {
                    required: [
                        'ProfessionalVerificationRequest:READ',
                        'ProfessionalVerificationRequest:UPDATE'
                    ]
                }
            },
            {
                name: 'professional-survei-request',
                path: 'survei-request',
                component: SurveiRequest,
                meta: {
                    required: ['SurveiRequest:READ', 'SurveiRequest:UPDATE']
                }
            },
            {
                name: 'professional-survei-request-detail',
                path: 'survei-request-detail/:id',
                component: SurveiRequestDetail,
                meta: {
                    required: ['SurveiRequest:READ', 'SurveiRequest:UPDATE']
                }
            },
            {
                name: 'professional-profession',
                path: 'profession',
                component: ProfessionList,
                meta: {
                    required: ['Profession:READ', 'Profession:UPDATE']
                }
            },
            {
                name: 'professional-profession-create',
                path: 'profession-create',
                component: ProfessionCreate,
                meta: {
                    required: ['Profession:READ', 'Profession:CREATE']
                }
            },
            {
                name: 'professional-profession-update',
                path: ':id/profession-update',
                component: ProfessionUpdate,
                meta: {
                    required: ['Profession:READ', 'Profession:UPDATE']
                }
            },
            {
                name: 'professional-skill',
                path: ':professionId/skill',
                component: SkillList,
                meta: {
                    required: ['Skill:READ', 'Skill:UPDATE']
                }
            },
            {
                name: 'professional-skill-create',
                path: ':professionId/skill-create',
                component: SkillCreate,
                meta: {
                    required: ['Skill:READ', 'Skill:CREATE']
                }
            },
            {
                name: 'professional-skill-update',
                path: ':professionId/:id/skill-update',
                component: SkillUpdate,
                meta: {
                    required: ['Skill:READ', 'Skill:UPDATE']
                }
            },
            { path: '', component: ProfessionalList }
        ]
    },
    {
        path: '/manage-payout',
        component: PayoutManage,
        meta: {
            required: []
        },
        children: [
            {
                name: 'payout-list',
                path: 'list',
                component: PayoutList,
                meta: {
                    required: ['Payout:READ', 'Payout:UPDATE']
                }
            }
        ]
    },
    {
        path: '/manage-referral',
        component: ReferralManage,
        meta: {
            required: []
        },
        children: [
            {
                name: 'member-referral',
                path: 'member-referral',
                component: MemberReferral,
                meta: {
                    required: ['MemberReferral:READ']
                }
            }
        ]
    },
    {
        path: '/manage-crowdfund',
        component: CrowdfundManage,
        meta: {
            required: ['Crowdfund:READ']
        },
        children: [
            {
                name: 'crowdfund-list',
                path: 'list',
                component: CrowdfundList,
                meta: {
                    required: 'Crowdfund:READ'
                }
            },
            {
                name: 'investor-list',
                path: 'investors',
                component: InvestorList,
                meta: {
                    required: 'Investment:READ'
                }
            },
            {
                name: 'crowdfund-convert-request',
                path: 'convert-request',
                component: ConvertRequest,
                meta: {
                    required: [
                        'ConversionRequest:READ',
                        'ConversionRequest:UPDATE'
                    ]
                }
            },
            {
                name: 'investment-history-list',
                path: 'investment-history-list',
                component: InvestmentHistoryList,
                meta: {
                    required: 'InvestmentHistory:READ'
                }
            },
            {
                name: 'marketplace-list',
                path: 'marketplace-list',
                component: MarketplaceList,
                meta: {
                    required: 'InvestmentMarketplace:READ'
                }
            },
            {
                name: 'crowdfund-update',
                path: ':id/update',
                component: CrowdfundUpdate,
                meta: {
                    required: ['Crowdfund:READ', 'Crowdfund:UPDATE']
                }
            },
            {
                name: 'crowdfund-propose',
                path: 'propose',
                component: CrowdfundPropose,
                meta: {
                    required: ['Crowdfund:READ', 'Crowdfund:CREATE']
                }
            },
            {
                name: 'investment-broadcast',
                path: 'investment-broadcast',
                component: InvestmentBroadcast,
                meta: {
                    required: ['BroadcastRecord:READ', 'BroadcastRecord:CREATE']
                }
            },
            {
                name: 'broadcast-list',
                path: 'broadcasts',
                component: BroadcastList,
                meta: {
                    required: 'BroadcastRecord:READ'
                }
            },
            {
                path: '',
                component: CrowdfundList,
                meta: {
                    required: ['Crowdfund:READ']
                }
            }
        ]
    },
    {
        path: '/manage-cms',
        component: CMSManage,
        meta: {
            required: []
        },
        children: [
            {
                name: 'compro',
                path: 'compro',
                component: Compro,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'membership-desc',
                path: 'membership-desc',
                component: MembershipDesc,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'hiw-agent-referral',
                path: 'hiw-agent-referral',
                component: HiwAgentReferral,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'hiw-crowdinvest',
                path: 'hiw-crowdinvest',
                component: HiwCrowdinvest,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'hiw-professional',
                path: 'hiw-professional',
                component: HiwProfessional,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'our-team-list',
                path: 'our-team-list',
                component: OurTeamList,
                meta: {
                    required: [
                        'OurTeam:READ',
                        'OurTeam:UPDATE',
                        'OurTeam:DELETE'
                    ]
                }
            },
            {
                name: 'our-team-create',
                path: 'our-team-create',
                component: OurTeamCreate,
                meta: {
                    required: ['OurTeam:CREATE']
                }
            },
            {
                name: 'our-team-update',
                path: ':id/our-team-update',
                component: OurTeamUpdate,
                meta: {
                    required: ['OurTeam:READ', 'OurTeam:UPDATE']
                }
            },
            {
                name: 'company-list',
                path: 'company-list',
                component: CompanyList,
                meta: {
                    required: [
                        'Company:READ',
                        'Company:UPDATE',
                        'Company:DELETE'
                    ]
                }
            },
            {
                name: 'company-create',
                path: 'company-create',
                component: CompanyCreate,
                meta: {
                    required: ['Company:CREATE']
                }
            },
            {
                name: 'company-update',
                path: ':id/company-update',
                component: CompanyUpdate,
                meta: {
                    required: ['Company:READ', 'Company:UPDATE']
                }
            },
            {
                name: 'faq',
                path: 'faq',
                component: Faq,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'risk-and-warning',
                path: 'risk-and-warning',
                component: RiskAndWarning,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'tnc',
                path: 'tnc',
                component: Tnc,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'privacy-policy',
                path: 'privacy-policy',
                component: PrivacyPolicy,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'cookie-policy',
                path: 'cookie-policy',
                component: CookiePolicy,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'basic-info',
                path: 'basic-info',
                component: BasicInfo,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            },
            {
                name: 'home-page',
                path: 'home-page',
                component: HomePage,
                meta: {
                    required: ['Content:READ', 'Content:UPDATE']
                }
            }
        ]
    },
    {
        path: '/manage-notification',
        component: NotificationManage,
        meta: {
            required: []
        },
        children: [
            {
                name: 'notification-broadcast',
                path: 'broadcast',
                component: NotificationBroadcast,
                meta: {
                    required: [
                        'Notification:READ',
                        'Notification:UPDATE',
                        'UserNotification:CREATE',
                        'UserNotification:READ'
                    ]
                }
            }
        ]
    },
    { name: 'no-permit', path: '/no-permit', component: NoPermit },
    { path: '*', component: Dashboard }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

const whiteListPaths = [
    '/login$',
    '/no-permit$',
    // eslint-disable-next-line
    '/admin-activation/[^/]+$',
    '/request-reset-password$',
    // eslint-disable-next-line
    '/reset-password/[^/]+$'
];

router.beforeEach((to, from, next) => {
    let regexpString = '';

    for (let index = 0; index < whiteListPaths.length; index++) {
        const element = whiteListPaths[index];
        if (index === 0) {
            regexpString = `${element}`;
        } else {
            regexpString = `${regexpString}|${element}`;
        }
    }
    let regexp = new RegExp(regexpString);

    if (regexp.test(to.path)) {
        next();
    } else {
        let token = localStorage.getItem('accessToken');
        if (token === null) {
            next('/login');
        } else {
            // check permission
            let permissions = JSON.parse(localStorage.getItem('rpem'));
            let meta = to.meta;
            let isAllow = util.checkPermission(
                meta.required || [],
                permissions
            );
            if (isAllow) {
                next();
            } else {
                next('/no-permit');
            }
        }
    }
});

export default router;
